import {Component, Input} from '@angular/core';
import {Property} from '../../../../shared/property/property.model';
import {ConfigStructure} from '../../../../config/config-structure.model';
import {AppConfigService} from '../../../../config/app-config.service';
import {AppUtils} from '../../../../shared/app-utils';

@Component({
  selector: 'app-museum-object-details',
  templateUrl: './museum-object-details.component.html',
  styleUrls: ['./museum-object-details.component.css']
})
export class MuseumObjectDetailsComponent {

  @Input() museumObject: any;

  properties: Property[];

  constructor(private appConfig: AppConfigService) {
  }

  ngOnInit() {
    this.properties = AppUtils.mapObjectToProperties(this.museumObject);
  }

  getConfig(): ConfigStructure[] {
    return this.appConfig.museumObjectDetailsConfig.museumObjectDetailsConfig;
  }
}
